import FetchService from "../FetchService/CustomService";
import { getErrorMessage } from "../utils";

const BaseUrl = process.env.BASE_URL;

const JobTitlesService = {
  /**
   * Fetch job titles from the API
   * @returns {Promise} API response with job titles data
   */
  async getJobTitles() {
    const url = BaseUrl + "/v2/metadata/job_titles";
    const loaderConfig = { hasLoader: false };

    try {
      const res = await FetchService.getCall({
        url,
        loaderConfig
      });

      return res;
    } catch (error) {
      console.log("JobTitlesService error:", error);
      return Promise.reject(getErrorMessage(error));
    }
  }
};

export default JobTitlesService;
